/** @jsx jsx */
import { jsx } from "theme-ui"

const Container = props => (
  <div
    sx={{
      width: [props.fluid ? "100%" : "90%"],
      maxWidth: "container",
      mx: "auto",
      ...props.styles,
    }}
    {...props}
  />
)

export default Container
